<template>
  <FormCreate
    :errors="errors"
    :fields="fields"
    model="pony"
    @submitted="create"
  >
    <!-- <pre>{{ formData }}</pre> -->
    <h4>Add Hair Colors</h4>
    <ul class="multi-list">
      <li v-for="hairColor in hairColors" :key="hairColor.value">
        <button
          class="elr-button elr-button-primary"
          :class="{ active: isActive(hairColor.value, formData.hair_colors) }"
          @click.prevent="addHairColor({hairColor: hairColor.value})"
        >{{hairColor.label}}</button>
      </li>
    </ul>
    <button @click.prevent="showHairColorModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    <h4>Add Themes</h4>
    <ul class="multi-list">
      <li v-for="theme in themes" :key="theme.value">
        <button
          class="elr-button elr-button-primary"
          :class="{ active: isActive(theme.value, formData.themes) }"
          @click.prevent="addTheme({theme: theme.value})"
        >{{theme.label}}</button>
      </li>
    </ul>
    <button @click.prevent="showThemeModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    <div class="elr-form-row">
      <InputText
        label="Pony Name"
        v-model="formData.name"
        fieldName="name"
        :errors="errors"
        :errorMessage="(errors && errors.name) ? errors.name[0] : null"
        :required=true
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Pose"
        v-model="formData.pose_id"
        fieldName="pose_id"
        :errors="errors"
        :errorMessage="(errors && errors.pose_id) ? errors.pose_id[0] : null"
        :required=true
        :values="poses"
      />
      <button @click.prevent="showPoseModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Species"
        v-model="formData.mold_id"
        fieldName="mold_id"
        :errors="errors"
        :errorMessage="(errors && errors.mold_id) ? errors.mold_id[0] : null"
        :required=true
        :values="molds"
      />
      <button
        @click.prevent="showMoldModal = true"
        class="icon-button"
      ><i class="fa fa-plus"></i></button>
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Character"
        v-model="formData.character_id"
        fieldName="character_id"
        :errors="errors"
        :errorMessage="(errors && errors.character_id) ? errors.character_id[0] : null"
        :required=true
        :values="characters"
      />
      <button @click.prevent="showCharacterModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Body Color"
        v-model="formData.body_color_id"
        fieldName="body_color_id"
        :errors="errors"
        :errorMessage="(errors && errors.body_color_id) ? errors.body_color_id[0] : null"
        :required=true
        :values="colors"
      />
      <button @click.prevent="showBodyColorModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Body Texture"
        v-model="formData.body_texture"
        fieldName="body_texture"
        :errors="errors"
        :errorMessage="(errors && errors.body_texture) ? errors.body_texture[0] : null"
        :required=true
        :values="bodyTextures"
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Eye Color"
        v-model="formData.eye_color"
        fieldName="eye_color"
        :errors="errors"
        :errorMessage="(errors && errors.eye_color) ? errors.eye_color[0] : null"
        :required=true
        :values="colorFamilies"
      />
      <InputSelect
        label="Eye Type"
        v-model="formData.eye_type"
        fieldName="eye_type"
        :errors="errors"
        :errorMessage="(errors && errors.eye_type) ? errors.eye_type[0] : null"
        :required=true
        :values="eyeTypes"
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Symbol Type"
        v-model="formData.symbol_type"
        fieldName="symbol_type"
        :errors="errors"
        :errorMessage="(errors && errors.symbol_type) ? errors.symbol_type[0] : null"
        :required=true
        :values="symbolTypes"
      />
      <InputSelect
        label="Symbol Texture"
        v-model="formData.symbol_texture"
        fieldName="symbol_texture"
        :errors="errors"
        :errorMessage="(errors && errors.symbol_texture) ? errors.symbol_texture[0] : null"
        :required=true
        :values="symbolTextures"
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Age"
        v-model="formData.age"
        fieldName="age"
        :errors="errors"
        :errorMessage="(errors && errors.age) ? errors.age[0] : null"
        :required=true
        :values="ages"
      />
      <InputSelect
        label="Gender"
        v-model="formData.gender"
        fieldName="gender"
        :errors="errors"
        :errorMessage="(errors && errors.gender) ? errors.gender[0] : null"
        :required=true
        :values="genders"
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Streak Color"
        v-model="formData.streak_color"
        fieldName="streak_color"
        :errors="errors"
        :errorMessage="(errors && errors.streak_color) ? errors.streak_color[0] : null"
        :required=true
        :values="colorFamilies"
      />
      <InputSelect
        label="Forelock Color"
        v-model="formData.forelock_color"
        fieldName="forelock_color"
        :errors="errors"
        :errorMessage="(errors && errors.forelock_color) ? errors.forelock_color[0] : null"
        :required=true
        :values="colorFamilies"
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Tinsel Color"
        v-model="formData.tinsel_color"
        fieldName="tinsel_color"
        :errors="errors"
        :errorMessage="(errors && errors.tinsel_color) ? errors.tinsel_color[0] : null"
        :required=true
        :values="colorFamilies"
      />
      <InputSelect
        label="Hair Texture"
        v-model="formData.hair_texture"
        fieldName="hair_texture"
        :errors="errors"
        :errorMessage="(errors && errors.hair_texture) ? errors.hair_texture[0] : null"
        :required=true
        :values="hairTextures"
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Hair Length"
        v-model="formData.hair_length"
        fieldName="hair_length"
        :errors="errors"
        :errorMessage="(errors && errors.hair_length) ? errors.hair_length[0] : null"
        :required=true
        :values="hairLengths"
      />
      <InputSelect
        label="Hoof Style"
        v-model="formData.hoof_style"
        fieldName="hoof_style"
        :errors="errors"
        :errorMessage="(errors && errors.hoof_style) ? errors.hoof_style[0] : null"
        :required=true
        :values="hoofStyles"
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Freckle Color"
        v-model="formData.freckle_color"
        fieldName="freckle_color"
        :errors="errors"
        :errorMessage="(errors && errors.freckle_color) ? errors.freckle_color[0] : null"
        :required=true
        :values="colorFamilies"
      />
      <InputSelect
        label="Patent Status"
        v-model="formData.patent_status"
        fieldName="patent_status"
        :errors="errors"
        :errorMessage="(errors && errors.patent_status) ? errors.patent_status[0] : null"
        :required=true
        :values="patentStatuses"
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Hoof Decoration"
        v-model="formData.hoof_mark_decoration"
        fieldName="hoof_mark_decoration"
        :errors="errors"
        :errorMessage="(errors && errors.hoof_mark_decoration) ? errors.hoof_mark_decoration[0] : null"
        :required=true
        :values="hoofDecorations"
      />
      <InputText
        label="Origin Language Name"
        v-model="formData.origin_lang_name"
        fieldName="origin_lang_name"
        :errors="errors"
        :errorMessage="(errors && errors.origin_lang_name) ? errors.origin_lang_name[0] : null"
      />
    </div>
    <div class="elr-form-row">
      <InputTextArea
        label="Notes"
        v-model="formData.notes"
        fieldName="notes"
        :errorMessage="(errors && errors.notes) ? errors.notes[0] : null"
      />
    </div>
    <div class="elr-form-row">
      <InputTextArea
        label="Symbol Description"
        v-model="formData.symbol_description"
        fieldName="symbol_description"
        :errorMessage="(errors && errors.symbol_description) ? errors.symbol_description[0] : null"
      />
    </div>
    <ModalWindow
      @close="showMoldModal = false"
      v-if="showMoldModal"
      modalId="moldModal"
      :showFooter="false"
      heading="Add a Species"
    >
      <FormMoldCreate @submitted="showMoldModal = false" />
    </ModalWindow>
    <ModalWindow
      @close="showPoseModal = false"
      v-if="showPoseModal"
      modalId="poseModal"
      :showFooter="false"
      heading="Add a Pose"
    >
      <FormPoseCreate @submitted="showPoseModal = false" />
    </ModalWindow>
    <ModalWindow
      @close="showCharacterModal = false"
      v-if="showCharacterModal"
      modalId="characterModal"
      :showFooter="false"
      heading="Add a Character"
    >
      <FormCharacterCreate @submitted="showCharacterModal = false" />
    </ModalWindow>
    <ModalWindow
      @close="showHairColorModal = false"
      v-if="showHairColorModal"
      modalId="hairColorModal"
      :showFooter="false"
      heading="Add a Hair Color"
    >
      <FormHairColorCreate @submitted="showHairColorModal = false" />
    </ModalWindow>
    <ModalWindow
      @close="showBodyColorModal = false"
      v-if="showBodyColorModal"
      modalId="bodyColorModal"
      :showFooter="false"
      heading="Add a Body Color"
    >
      <FormBodyColorCreate @submitted="showBodyColorModal = false" />
    </ModalWindow>
    <ModalWindow
      @close="showThemeModal = false"
      v-if="showThemeModal"
      modalId="themeModal"
      :showFooter="false"
      heading="Add a Theme"
    >
      <FormThemeCreate @submitted="showThemeModal = false" />
    </ModalWindow>
  </FormCreate>
</template>

<script>
import { mapActions } from 'vuex';
import { validate } from '../../utils/validation';
import {
  colorFamilies,
  symbolTextures,
  ages,
  bodyTextures,
  eyeTypes,
  symbolTypes,
  genders,
  hairTextures,
  hairLengths,
  hoofStyles,
  patentStatuses,
  hoofDecorations,
} from '../../data/config.json';
import FormCreate from '../FormCreate/FormCreate';
import InputText from '../InputText/InputText';
import InputSelect from '../InputSelect/InputSelect';
import InputTextArea from '../InputTextArea/InputTextArea';
import ModalWindow from '../ModalWindow/ModalWindow';
import FormMoldCreate from '../FormMoldCreate/FormMoldCreate';
import FormPoseCreate from '../FormPoseCreate/FormPoseCreate';
import FormThemeCreate from '../FormThemeCreate/FormThemeCreate';
import FormCharacterCreate from '../FormCharacterCreate/FormCharacterCreate';
import FormBodyColorCreate from '../FormBodyColorCreate/FormBodyColorCreate';
import FormHairColorCreate from '../FormHairColorCreate/FormHairColorCreate';

export default {
  name: 'FormPonyCreate',
  props: {
    groupId: {
      type: [Number, String],
      required: true,
    }
  },
  data() {
    return {
      colorFamilies,
      symbolTextures,
      ages,
      bodyTextures,
      eyeTypes,
      symbolTypes,
      genders,
      hairTextures,
      hairLengths,
      hoofStyles,
      patentStatuses,
      hoofDecorations,
      formData: {
        name: null,
        pose_id: null,
        character_id: null,
        mold_id: null,
        body_color_id: null,
        eye_color: 'unknown',
        eye_type: 'painted',
        symbol_type: 'hip',
        symbol_texture: 'painted',
        streak_color: 'none',
        forelock_color: 'none',
        tinsel_color: 'none',
        hair_texture: 'straight',
        hair_length: 'medium',
        hoof_style: 'concave',
        body_texture: 'plastic',
        age: 'adult',
        gender: 'female',
        patent_status: 'unknown',
        freckle_color: 'none',
        origin_lang_name: null,
        grouping_id: this.groupId,
        notes: null,
        symbol_description: null,
        hoof_mark_decoration: 'none',
        themes: [],
        hair_colors: [],
      },
      fields: [
        {
          name: 'name',
          label: 'Pony Name',
          type: 'text',
          rules: 'required|isAlphaSpaces|isMinLength:2|isMaxLength:50',
        },
        {
          name: 'grouping_id',
          rules: 'required',
          type: 'select',
          label: 'Grouping'
        },
        {
          name: 'pose_id',
          rules: 'required',
          type: 'select',
          label: 'Pose'
        },
        {
          name: 'notes',
          label: 'Description',
          type: 'textarea',
          // rules: 'isMaxLength:300'
        },
        {
          name: 'symbol_description',
          label: 'Symbol Description',
          type: 'textarea',
          // rules: 'isMaxLength:300'
        },
      ],
      showMoldModal: false,
      showPoseModal: false,
      showThemeModal: false,
      showHairColorModal: false,
      showBodyColorModal: false,
      showCharacterModal: false,
    };
  },
  components: {
    FormCreate,
    InputSelect,
    InputText,
    InputTextArea,
    ModalWindow,
    FormMoldCreate,
    FormPoseCreate,
    FormCharacterCreate,
    FormBodyColorCreate,
    FormHairColorCreate,
    FormThemeCreate,
  },
  mounted() {
    this.$store.dispatch('pose/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('character/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('mold/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('bodyColor/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('theme/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('hairColor/FETCH_ALL', {
      num: 100
    });
  },
  computed: {
    errors() {
      return (this.$store && this.$store.state.pony.errors) ? this.$store.state.pony.errors[0] : {};
    },
    poses() {
      const poses = this.$store.getters['pose/getAll'];

      return poses.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
    molds() {
      const molds = this.$store.getters['mold/getAll'];

      return molds.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
    characters() {
      const characters = this.$store.getters['character/getAll'];

      return characters.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
    themes() {
      const themes = this.$store.getters['theme/getAll'];

      return themes.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
    colors() {
      const colors = this.$store.getters['bodyColor/getAll'];

      return colors.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
    hairColors() {
      const hairColors = this.$store.getters['hairColor/getAll'];

      return hairColors.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
  },
  methods: {
    ...mapActions('pony', ['ADD', 'RESET_ERRORS']),
    ...mapActions('notification', ['ERROR_NOTIFICATION']),
    isActive(value, list) {
      if (Array.isArray(list)) {
        return list.includes(value);
      }
    },
    validate(data) {
      const errors = validate(this.fields, data);

      if (this.hasErrors(errors)) {
        this['ERROR_NOTIFICATION']('could not add pony. fix errors and try again.');
        this.$emit('error', { errors });

        return true
      }

      return false;
    },
    hasErrors(errors) {
      if (errors) {
        return !!Object.keys(errors).length;
      }

      return false;
    },
    inErrors(errors, field) {
      if (!this.hasErrors(errors)) {
        return;
      }

      const keys = Object.keys(errors);

      return keys.includes(field)
    },
    addTheme({ theme }) {
      if (this.formData.themes.includes(theme)) {
        this.formData.themes = this.formData.themes.filter(o => {
          o.value !== theme;
        });
      } else {
        this.formData.themes.push(theme);
      }
    },
    addHairColor({ hairColor }) {
      if (this.formData.hair_colors.includes(hairColor)) {
        this.formData.hair_colors = this.formData.hair_colors.filter(o => {
          o.value !== hairColor;
        });
      } else {
        this.formData.hair_colors.push(hairColor);
      }
    },
    resetForm() {
      this.formData = {
        name: null,
        pose_id: null,
        character_id: null,
        mold_id: null,
        body_color_id: null,
        eye_color: 'unknown',
        eye_type: 'painted',
        symbol_type: 'hip',
        symbol_texture: 'painted',
        streak_color: 'none',
        forelock_color: 'none',
        tinsel_color: 'none',
        hair_texture: 'straight',
        hair_length: 'medium',
        hoof_style: 'concave',
        body_texture: 'plastic',
        age: 'adult',
        gender: 'female',
        patent_status: 'unknown',
        freckle_color: 'none',
        origin_lang_name: null,
        grouping_id: this.groupId,
        notes: null,
        symbol_description: null,
        hoof_mark_decoration: 'none',
        themes: [],
        hair_colors: [],
      };
    },
    create() {
      if (this.validate(this.formData)) {
        return;
      }

      window.scrollTo(0, 0);
      this.ADD(this.formData);
      this.RESET_ERRORS();
      this.resetForm();
      this.$emit('submitted', { data: this.formData });
    }
  }
};
</script>
